import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirestoreSlideDeckAuthor } from '../firestore/SlideDeckAuthor/schema'
import { emptySlideDeckAuthor } from '../firestore/SlideDeckAuthor/schema'
import type { FirebaseRepository } from './FirebaseRepository'
import { computed, makeObservable } from 'mobx'

export class SlideDeckAuthor extends ObservableModelWithDecorators<FirestoreSlideDeckAuthor> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, emptySlideDeckAuthor)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, emptySlideDeckAuthor)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideDeckAuthor>
  ) {
    super(repository, doc)
    makeObservable(this)
  }

  @computed
  get isGlobalAuthor() {
    return !!this.data.globalAuthorId
  }

  @computed
  get isHiddenGlobalAuthor() {
    const { globalAuthorId } = this.data
    if (!globalAuthorId) return false

    const globalAuthor =
      this.repository.globalAuthorStore.getAuthor(globalAuthorId)

    return globalAuthor.data.hidden === true
  }

  @computed
  get canShow() {
    if (!this.isGlobalAuthor) return true

    const globalAuthor = this.repository.globalAuthorStore.getAuthor(
      this.data.globalAuthorId!
    )

    return !!globalAuthor.data.authorName
  }

  @computed
  get resolvedData() {
    const { globalAuthorId } = this.data
    if (!globalAuthorId) return { ...this.data, hidden: false }

    const globalAuthor =
      this.repository.globalAuthorStore.getAuthor(globalAuthorId)

    if (!globalAuthor.data.authorName) {
      return { ...this.data, hidden: false }
    }

    return {
      ...this.data,
      authorName: globalAuthor.data.authorName,
      authorTitle: globalAuthor.data.authorTitle,
      authorBio: globalAuthor.data.authorBio,
      authorInstitution: globalAuthor.data.authorInstitution,
      authorImageURL:
        globalAuthor.data.authorImageURL || this.data.authorImageURL,
      hidden: globalAuthor.data.hidden === true,
    }
  }
}
